import type { Conversation } from '../types/agent';
import { serializeConversationLiveView } from './liveView';

export function buildConversationSettings(conv: Conversation): Record<string, unknown> {
  const liveView = serializeConversationLiveView(conv.liveView);
  const settings = { ...(conv.workspaceSettings ?? {}) };
  if (conv.mode === 'doc-agent') {
    // Document endpoints own these pointers. A chat-settings sync can race
    // an AI commit and must never send the previous file revision back.
    delete settings.docAgentFileId;
    delete settings.docAgentSourceFileId;
    delete settings.docAgentFormat;
  }
  return {
    ...settings,
    startPagePending: conv.startPagePending,
    startPageState: conv.startPageState,
    ...(conv.pinnedAt ? { pinnedAt: conv.pinnedAt } : {}),
    ...(conv.sharedGroup ? { sharedGroup: conv.sharedGroup } : {}),
    ...(liveView ? { liveView } : {}),
  };
}
